import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/me.jpg`} alt="" />
      </Link>
      <header>
        <h2>Simran Singh</h2>
        <p><a href="mailto:admin@simransingh.in">admin@simransingh.in</a></p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>Hi, I&apos;m Simran Singh. I like building things.
        I am a B.Tech graduate, and
        the Freelancer Software Developer. Before Freelancing I was
        at <a href="https://www.impingesolutions.com/">Impinge Solution</a>,
        <a href="http://www.sachtechsolution.com/">Sachtech Solution</a>
        , <a href="https://www.facebook.com/stdio.corps">Stdio Corps</a>
        , <a href="https://www.cordia.edu.in/">Cordia Group</a>
        , <a href="https://eclerx.com/">eClerx</a>
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? <Link to="/resume" className="button">Learn More</Link> : <Link to="/about" className="button">About Me</Link>}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">&copy; Simran Singh <Link to="/">simransingh.in</Link>.</p>
    </section>
  </section>
);

export default SideBar;
